import * as Yup from 'yup'
import { t } from '../../../adapters/translate/translate'

export const getValidationSchemaByName = (name: any) => {
  if (!Array.isArray(name)) {
    switch (name) {
      case 'inputRequired':
        return Yup.string()
          .required(t('Required field'))
      case 'emailRequired':
        return Yup.string()
          .email(t('E-mail is invalid'))
          .required(t('E-mail is required'))
      case 'passwordMinRequired':
        return Yup.string()
          .min(8, t('Password must have 8 characters at least'))
          .required(t('Required field'))
      case 'passwordWithMatches':
        return Yup.string()
          .min(8, t('Password should have 8 characters at least'))
          .matches(/[0-9]/, t('Password should have 1 number at least'))
          .matches(/[a-z]/, t('Password should have 1 lowercase letter at least'))
          .matches(/[A-Z]/, t('Password should have 1 uppercase letter at least'))
          .matches(/[!@#$%*()_/\\\-+^&{}:;?.]/, t('Password should have 1 special character at least'))
          .required(t('Password is required'))
      case 'confirmPassword':
        return Yup.string().when('password', {
          is: (val: any) => val && val.length >= 6,
          then: Yup.string()
            .oneOf([Yup.ref('password')], t('ValidatePasswordNotEquals'))
            .required(t('Required field'))
        })
      case 'inputRequiredCode':
        return Yup.string()
          .required(t('Required field'))
          .matches(/[0-9]/, t('ValidateOnlyNumbers'))
      case 'isValidName':
        return Yup.string()
          .required(t('Required field'))
          .min(2, t('ValidateMinName'))
      default: throw new Error(`Validation ${name} don't found`)
    }
  }
}
